import SuspenseRoute from "@/components/SuspenseRoute";
import useAuth from "@/hooks/useAuth";
import AppLayout from "@/layouts/AppLayout";
import LogoutPage from "@/pages/auth/LogoutPage";
import ContactUsPage from "@/pages/contact-us/ContactUsPage";
import ErrorsPage from "@/pages/errors/ErrorsPage";
import { lazyImport } from "@/utils/functions";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

const AuthPage = lazyImport(() => import("@/pages/auth/AuthPage"));
const PrivateRoutes = lazyImport(() => import("@/routes/PrivateRoutes"));
const TabletPrivateRoutes = lazyImport(
  () => import("@/routes/TabletPrivateRoutes")
);

const AuthTabletPage = lazyImport(() => import("@/pages/auth/AuthTabletPage"));

const AppRoute = () => {
  const { user, isTabletUser, setIsTabletUser } = useAuth();
  // useEffect(() =>{
  //   if(location.pathname === "/auth/login")
  //     setIsTabletUser(false);
  // },[location.pathname])

  return (
    <BrowserRouter basename={import.meta.env.BASE_URL}>
      <Routes>
        <Route element={<AppLayout />}>
          <Route path="error/*" element={<ErrorsPage />} />
          <Route path="contact-us/*" element={<ContactUsPage />} />
          <Route path="logout" element={<LogoutPage />} />
          {user ? (
            isTabletUser ? (
              <>
                <Route
                  path="/*"
                  element={
                    <SuspenseRoute>
                      <TabletPrivateRoutes />
                    </SuspenseRoute>
                  }
                />
                <Route index element={<Navigate to="/trip/home" />} />
              </>
            ) : (
              <>
                <Route
                  path="/*"
                  element={
                    <SuspenseRoute>
                      <PrivateRoutes />
                    </SuspenseRoute>
                  }
                />
                <Route index element={<Navigate to="/dashboard" />} />
              </>
            )
          ) : (
            <>
              <Route
                path="auth/*"
                element={
                  <SuspenseRoute>
                    <AuthPage />
                  </SuspenseRoute>
                }
              />
              <Route
                path="auth-tablet/*"
                element={
                  <SuspenseRoute>
                    <AuthTabletPage />
                  </SuspenseRoute>
                }
              />
              <Route
                index
                element={
                  <Navigate to={isTabletUser ? "/auth-tablet" : "/auth"} />
                }
              />
              <Route
                path="*"
                element={
                  <Navigate to={isTabletUser ? "/auth-tablet" : "/auth"} />
                }
              />
            </>
          )}
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoute;
